// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartConfigWinchStand } from './part-config-winch-stand';
import { PartConfigWinchStandOption } from './part-config-winch-stand-option';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigWinchStandOptionLink extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  isDefault!: boolean;
  partConfigWinchStandId!: number;
  partConfigWinchStandOptionId!: number;
  partConfigWinchStand!: PartConfigWinchStand;
  partConfigWinchStandOption!: PartConfigWinchStandOption;
}

